/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/topicsSplit/miniLearner/highlightedTranscript/highlightedTranscriptView",
  "modules/learner/learnerTranscriptModal/learnerTranscriptModalModule",
], function (Marionette, Messenger, HighlightedTranscriptView, LearnerTranscriptModalModule) {
  var HighlightedTranscriptController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "highlightedTranscript";
      this.region = options.region;
    },
    show: function (transcript) {
      this.view = new HighlightedTranscriptView.highlightedTranscriptView({ model: transcript });
      var matchType = Messenger.reqres.request("learner:results:match:type");
      //open the transcript's modal
      this.view.on(
        "select:transcript",
        function () {
          //determine the title used based on whether this is a question or a cluster
          let modalTitle;
          if (transcript.isCluster) {
            modalTitle = "learner.transcript.clusteredTitle";
          } else {
            modalTitle = "learner.transcript.title";
          }
          Messenger.vent.trigger(
            "show:modal",
            LearnerTranscriptModalModule,
            {
              matchType: matchType,
              disableLearnerFeatures: false,
            },
            transcript,
            {
              title: modalTitle,
              closeButton: true,
              closeOnBackgroundClick: true,
              trackInteraction: {
                action: "Show Learner Transcript",
                object: "Learner Transcript",
                source: "Highlighted Transcript",
              },
            },
          );
        },
        this,
      );

      this.view.on(
        "dragged:item",
        function () {
          //set up a reqres for the dragged object when the drag begins (needs to be set up here so it overrides any existing reqres)
          Messenger.reqres.setHandler(
            "dragged:model",
            function () {
              return transcript;
            },
            this,
          );
        },
        this,
      );
      //close the view when the model is removed(which occurs when a model is deleted or status is changed)
      transcript.once(
        "remove",
        function () {
          this.view.close();
        },
        this,
      );
      this.showRegion(this.view);
    },
  });

  return HighlightedTranscriptController;
});
